import { useLocalSearchParams } from 'expo-router'
import EventView from '~/components/events/EventView'
import ScreenView from '~/components/layout/ScreenView'

export default function EventDetailsPage() {
  const { eventId } = useLocalSearchParams<{
    eventId: string
  }>()

  return (
    <ScreenView>
      <EventView eventId={eventId} />
    </ScreenView>
  )
}
